import type {VariantProps} from 'tailwind-variants';
import {tv} from 'tailwind-variants';
import {default as CarouselCard} from './CarouselCard.svelte';

export const carouselCardTvProps = tv({
  slots: {
    base: `
      overflow-hidden
      flex-[0_0_50%] 
      min-w-0 
      first-of-type:ml-[25%] 
      last-of-type:mr-[25%] 
      bg-[var(--carousel-card-slots-base-bg-color)]
      border-[length:var(--carousel-card-slots-base-border)]
      border-[var(--carousel-card-slots-base-outline-color)]
      rounded-[var(--carousel-card-slots-base-border-radius)]
      select-none
    `,
  },
  variants: {
    selected: {
      true: {
        base: `
          border-[var(--carousel-card-variants-state-selected-outline-color)]
        `,
      },
    },
  },
  defaultVariants: {},
});

export type CarouselCardTvProps = VariantProps<typeof carouselCardTvProps>;

export type CarouselCardProps = Omit<
  HTMLDivElement,
  'role' | 'tabindex' | 'aria-checked' | 'class'
>;

export {CarouselCard};
